module.exports = __webpack_public_path__ + "img/image-vertical-dark.e8cead4d.svg";